export default {
  // Settings Page
  PickGameTitle: "Spin the Whell - Settings",
  candidatesLabel: "Candidate Item Settings",
  candidatesPlaceholder: "Enter candidate items, separated by line breaks or commas (,), press Enter to add items, maximum 20 candidates, random selection if exceed 10",
  clearSettings: "Clear Settings",
  saveSettings: "Save Settings",
  candidateExists: "Candidate already exists",
  maxCandidates: "Maximum 20 candidates allowed",
  unsubmittedWarning: "Unsubmitted items found in the input field. Please confirm and press Enter before saving!",

  // Game Page
  gameTitle: "Spin the Wheel",
  spinWheel: "Spin the Wheel",
  winner: "Winner",
  spinAgain: "Spin Again",
  backToSettings: "Back to Settings"
}